import { FileText } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'

export const UPLOADED_DOCUMENT_FILE_ICON_SIZE = 16

type UploadedDocumentFileNameHeaderProps = {
  fileName: string
  className?: string
  onActivate?: () => void
  activateDisabled?: boolean
}

export function UploadedDocumentFileNameHeader({
  fileName,
  className,
  onActivate,
  activateDisabled,
}: UploadedDocumentFileNameHeaderProps) {
  const nameClass =
    'min-w-0 flex-1 truncate text-sm font-semibold leading-snug text-green-900'

  return (
    <div className={cn('flex min-w-0 items-center gap-2', className)}>
      <FileText
        size={UPLOADED_DOCUMENT_FILE_ICON_SIZE}
        className="shrink-0 text-green-600"
        strokeWidth={2}
        aria-hidden
      />
      {onActivate ? (
        <button
          type="button"
          className={cn(
            nameClass,
            'text-left hover:text-sky-700 hover:underline disabled:cursor-not-allowed disabled:opacity-60 disabled:no-underline',
          )}
          disabled={activateDisabled}
          onClick={onActivate}
          title={fileName}
        >
          {fileName}
        </button>
      ) : (
        <p className={nameClass} title={fileName}>
          {fileName}
        </p>
      )}
    </div>
  )
}
